.root {
    --color: var(--mid-gray);

    background: var(--color);
    color: var(--color);
    flex-shrink: 0;

    --thiccness: 1px;

    height: var(--thiccness);
    width: 100%;

    :where(&:not([aria-orientation="vertical"])) {
        grid-column: content;
    }

    &:where([aria-orientation="vertical"]) {
        width: var(--thiccness);
        height: 2lh;
    }
}
